<form class="skills-form" [formGroup]="skillForm" (ngSubmit)="onSubmit()">
  <div class="form-row">
    <div class="form-group">
      <label class="form-label" for="skillName">
        {{ 'profile.skill.name' | transloco }}
        <span class="required-indicator">*</span>
      </label>
      @if (allCVOptionsFromDB) {
      <app-skill-selector
        [allCVOptionsFromDB]="allCVOptionsFromDB"
        [placeholder]="'profile.skill.selectSkill' | transloco"
        [appearance]="'outline'"
        [cssClass]="'w-100'"
        [testId]="'profile-skill'"
        [initialExpandedCategory]="editingSkillCategory"
        [styleVariant]="'jobs'"
        formControlName="skillName"></app-skill-selector>
      }
      @if (skillForm.get('skillName')?.invalid && skillForm.get('skillName')?.touched) {
        <div class="error-message">
          @if (skillForm.get('skillName')?.errors?.['maxlength']) {
            {{ 'validation.databaseConstraint.skillName' | transloco: {max: VALIDATION.SKILL_NAME_MAX_LENGTH} }}
          } @else {
            {{ 'validation.required.skillName' | transloco }}
          }
        </div>
      }
    </div>
    <div class="form-group">
      <app-select
        id="level"
        formControlName="level"
        [label]="'profile.skill.level' | transloco"
        [placeholder]="'profile.skill.selectLevel' | transloco"
        [options]="skillLevelOptions"
        [required]="true"
        [errorMessage]="skillForm.get('level')?.invalid && skillForm.get('level')?.touched ? ('validation.required.level' | transloco) : ''"></app-select>
    </div>
  </div>
  <div class="form-actions">
    <app-button type="button" variant="outline" color="secondary" (click)="onCancel()">
      {{ 'button.cancel' | transloco }}
    </app-button>
    <app-button type="submit" variant="filled" [disabled]="skillForm.invalid">
      {{ 'button.save' | transloco }}
    </app-button>
  </div>
</form>
